// components/common/SessionTimeout.tsx
import * as React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRefresh,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./SessionTimeout.scss";

interface SessionTimeoutProps {
  onRefresh?: () => void;
}

const SessionTimeout: React.FC<SessionTimeoutProps> = ({ onRefresh }) => {
  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "1rem",
      }}
    >
      <Card
        style={{
          maxWidth: "480px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Card.Body
          style={{
            padding: "2rem 1.5rem",
          }}
          className="session-timeout-body"
        >
          <div
            style={{
              fontSize: "3.5rem",
              color: "#f59e0b",
              marginBottom: "1.5rem",
            }}
          >
            <FontAwesomeIcon icon={faExclamationCircle} />
          </div>

          <h3
            style={{
              fontSize: "1.5rem",
              fontWeight: 600,
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            Your Session Has Paused
          </h3>

          <p
            style={{
              fontSize: "1rem",
              color: "#6b7280",
              marginBottom: "2rem",
              lineHeight: 1.6,
            }}
          >
            Due to inactivity, your session has been closed. Simply refresh the
            page to continue where you left off.
          </p>

          <Button
            variant="primary"
            size="lg"
            onClick={handleRefresh}
            style={{
              minWidth: "200px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
            }}
          >
            <FontAwesomeIcon icon={faRefresh} />
            Continue Session
          </Button>

          <p
            style={{
              fontSize: "0.875rem",
              color: "#9ca3af",
              marginTop: "1.5rem",
              marginBottom: 0,
            }}
          >
            If the problem persists, please contact support.
          </p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SessionTimeout;
